import { Colors } from "../consts/Colors";
import { Sizes } from "../consts/Sizes";
import ButtonRounded from "./ButtonRounded";

export default class Fish extends Phaser.GameObjects.Container {
  constructor(scene, x, y, index) {
    super(scene, x * 2.8, y);
    scene.add.existing(this);
    this.scene = scene;

    this.illu = this.scene.add.image(0, 0, "fish" + index);
    this.add(this.illu);
    this.setSize(this.illu.width, this.illu.height);
    this.setScale(1);
    this.setInteractive({ useHandCursor: true });
    this.on("pointerdown", () => {
      if (index === 3) {
        this.scene.addDebrief2(true);
      } else {
        this.scene.addDebrief2(false);
      }
    });
  }
}
